import { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Menu } from '@headlessui/react'
import { motion, AnimatePresence } from 'framer-motion'
import { MenuIcon } from '@heroicons/react/outline'
import styles from './Dropdown.module.scss'

Dropdown.propTypes = {
  groups: PropTypes.arrayOf(
    PropTypes.arrayOf(PropTypes.element)
  ).isRequired
}

export default function Dropdown ({ groups }) {
  const variants = {
    hidden: {
      opacity: 0,
      scale: 0.85,
      transition: {
        duration: 0.15,
        ease: 'easeIn'
      }
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.15,
        ease: 'easeInOut'
      }
    }
  }

  const Groups = groups.map((group, index) => {
    return (
      <Fragment key={ index }>
        <div className={ styles['items-group'] }>
          {
            group.map((item, _index) => {
              return (
                <Menu.Item
                  key={ _index }
                  className={ styles.item }>
                  { item }
                </Menu.Item>
              )
            })
          }
        </div>

        { index !== groups.length - 1 && <hr/> }
      </Fragment>
    )
  })

  return (
    <Menu
      as="div"
      className={ styles.container }>
      {
        ({ open }) => (
          <>
            <Menu.Button
              className={ styles.button }
              aria-label="Навигация">
              <MenuIcon className={ styles.icon } />
            </Menu.Button>

            <AnimatePresence>
              {
                open &&
                  <motion.div style={ { position: 'absolute' } } // FIXME
                    variants={ variants }
                    initial="hidden"
                    exit="hidden"
                    animate={ open ? 'visible' : 'hidden' }>
                    <Menu.Items
                      className={ styles.items }
                      static={ true }>
                      { Groups }
                    </Menu.Items>
                  </motion.div>
              }
            </AnimatePresence>
          </>
        )
      }
    </Menu>
  )
}
